
import {formatArea, formatCurrency} from "../utils/functions";
import Workmode from "../classes/Workmode";
import WorkmodeAll from "../classes/WorkmodeAll";
import WorkmodeProject from "../classes/WorkmodeProject";
import WorkmodeRoads from "../classes/WorkmodeRoads";
import WorkmodePower from "../classes/WorkmodePower";
import WorkmodeComp from "../classes/WorkmodeComp";
import ToolTurbine from "../classes/ToolTurbine";
import Country from "../classes/Country";

const wmConfig = {
	user: null,
	defaultWorkmode : "default",
	workmodes : [
		{
			label:"All",
			value:'',
			visible: true,
			countries:['no','se','ee', 'lv'],
			columns:[

			],
			tableFooter : ()=>{
				
			},
			obj: new WorkmodeAll(),
			_extraLayers: [
				
				{
					id: "cadastral-all",
					name: "Properties with owners",
					source : {
						type: 'vector',
						id: "cadastral-all",
						promoteId: [{layer: 'cadastral_{countryCode}', property: 'fid'}, {layer: 'landowners_{countryCode}', property: 'id'}],
						tiles: ['https://tiles1.vindrtech.com/tiles/landowners_{countryCode},cadastral_{countryCode}/{z}/{x}/{y}?apikey='+process.env.REACT_APP_TILES_API_KEY]
					},
					layer:[
						{
							'id': 'cadastral-unknown-fill-line',
							'type': 'line',
							'minzoom': 13,
							'source': 'cadastral-all',
							'source-layer': 'cadastral_{countryCode}',
							'paint': {
								'line-color': '#000000',
								'line-opacity': ['case', ['in', ['get', 'vindrid'], ["literal", []]], 1, 1],
							}
						},
						{
							'id': 'cadastral-unknown-fill',
							'type': 'fill',
							'minzoom': 13,
							'source': 'cadastral-all',
							'source-layer': 'cadastral_{countryCode}',
							'paint': {
								'fill-color':['case',
									
									['boolean', ["to-boolean", ['feature-state', 'color']], false],['feature-state', 'color'],
									['boolean', ['feature-state', 'fetched'], false],'#ffffff',
									
									'#e5e9f1'
								] ,
								'fill-opacity': ['case', 
									['==', ['get', 'known_owner'], 1], 0,									
									parseFloat(process.env.REACT_APP_REST_OPACITY)
								]
							}
						},
						{
							'id': 'cadastral-known-fill',
							'type': 'fill',
							'minzoom': 13,
							'source': 'cadastral-all',
							'source-layer': 'landowners_{countryCode}',
							'paint': {
								'fill-color': ['case',                             // Start a conditional expression
									['boolean', ["to-boolean", ['feature-state', 'removecolor']], false], process.env.REACT_APP_PLOT_NO_OWNER_COLOR,
							        ['all', ['has', 'color'],['!=', ['get', 'color'], '']],                   // Check if the 'color' property exists
							        ['get', 'color'],                   // If true, use the color from the data
							        '#FFFFFF'                           // Otherwise, use white color
							    ],
								'fill-opacity': ['case', 
									["==",['length', ["literal", []]], 0], parseFloat(process.env.REACT_APP_REST_OPACITY),
									['in', ['get', 'propertyid'], ["literal", []]], parseFloat(process.env.REACT_APP_ACTIVE_OPACITY), 

									parseFloat(process.env.REACT_APP_DIMM_OPACITY)
								]
							}
						},
						{
							'id': 'cadastral-known-fill-line',
							'type': 'line',
							'minzoom': 13,
							'source': 'cadastral-all',
							'source-layer': 'landowners_{countryCode}',
							'paint': {
								'line-color': ['case', 
									['boolean', ["to-boolean", ['feature-state', 'removecolor']], false], '#000000',
									['in', ['get', 'vindrid'], ["literal", []]], ['get', 'color'], 
									'#000000'
								],
								'line-width': ['case', 
									['in', ['get', 'vindrid'], ["literal", []]], parseFloat(process.env.REACT_APP_ACTIVE_LINE_WIDTH), 
									parseFloat(process.env.REACT_APP_REST_LINE_WIDTH)
								],
								'line-opacity': ['case', 
									['in', ['get', 'vindrid'], ["literal", []]], parseFloat(process.env.REACT_APP_ACTIVE_OPACITY), 
									parseFloat(process.env.REACT_APP_LINE_REST_OPACITY)
								]
							}
						},
						
						{
							'id': 'cadastral-unknown-fill-label',
							'type': 'symbol',
							'minzoom': 13,
							'source': 'cadastral-all',
							'source-layer': 'cadastral_{countryCode}',
							"layout": {
							    "text-field": ["get", "vindrid"], // Assuming 'name' is the property you want to label with
							    "text-allow-overlap": false,
							    "text-padding": 10,
							    "text-size": [
							      "interpolate",
							      ["linear"],
							      ["zoom"],
							      12, 11, 
							      15, 16  
							    ],
							    "text-max-width": 8,
							    "text-anchor": "center",
							    "text-offset": [0, 0],
							    "text-optional": true,
							    "text-variable-anchor": ["center", "top", "bottom", "left", "right"]
							  },
							  "paint": {
							    "text-color": "#000000"
							  },
							  "filter": ["==", "$type", "Polygon"]
						}
					]
				}
			]
		},
		{
			label:"Project",
			value:'default',
			visible: true,
			countries:['no','se','ee', 'lv'],
			columns:[
				{
					name: 'Area',
					id:'totalArea',
					selector: row => row.totalArea,
					sortable:true,
					format: (cell) => `${cell.totalArea.toLocaleString()} %`,
					right: "true",
					width: "55px",
				},
				{
					name: 'Turbines',
					id:'turbines',
					selector: row => row.turbines,
					sortable:true,
					center: "true",
					width: "65px",
					style: {
						paddingRight: '0',
					}
				}
			],
			obj: new WorkmodeProject(),
			tableFooter : ()=>{
				
			}
		},
		{
			label:"Road",
			value:'road',
			visible: true,
			countries:['no','se','ee', 'lv'],
			columns:[
				{
					name: 'Affected area',
					id:'totalArea',
					selector: row => row.affectedArea,
					sortable:true,
					format: (cell) => `${formatArea(cell.affectedArea, wmConfig.user)}`,
					right: "true",
					width: "100px",
					
				}
			],
			obj:  new WorkmodeRoads(),
			tableFooter : (data)=>{
				
				const total = data.map((o)=>{return o.properties.map((a)=>{return a.area}).reduce((partialSum, a) => partialSum + a, 0)}).reduce((partialSum, a) => partialSum + a, 0);
				
				
				return <div className="table-footer road"><div>Total affected area</div><div>{formatArea(total, wmConfig.user)}</div></div>
			}
			
		},
		{
			label:"Power",
			value:'power',
			visible: true,
			countries:['no','se','ee', 'lv'],
			columns:[
				{
					name: 'Affected area',
					id:'totalArea',
					selector: row => row.affectedArea,
					sortable:true,
					format: (cell) => `${formatArea(cell.affectedArea, wmConfig.user)}`,
					right: "true",
					width: "100px",
				}
			],
			obj: new WorkmodePower(),
			tableFooter : (data)=>{
				
				const total = data.map((o)=>{return o.properties.map((a)=>{return a.area}).reduce((partialSum, a) => partialSum + a, 0)}).reduce((partialSum, a) => partialSum + a, 0);
				
				
				return <div className="table-footer power"><div>Total affected area</div><div>{formatArea(total, wmConfig.user)}</div></div>
			}
			
		},
		{
			label:"Compensation",
			value:'compensation',
			visible: true,
			countries:['se','ee'],
			columns:[
				
				{
					name: 'Compensation',
					id:'compensation',
					selector: row => row.compensation,
					sortable:true,
					format: (cell) => `${formatCurrency(cell.compensation, wmConfig.country)}`,
					right: "true",
				}
			],
			obj: new WorkmodeComp(),
			tableFooter : (data)=>{
				const total = data.reduce((partialSum, a) => partialSum + (isNaN(a.compensation) ? 0 : a.compensation), 0);
				
				
				return <div className="table-footer power"><div>Total compensation</div><div>{formatCurrency(total, wmConfig.country)}</div></div>
			}
			
		}
		
		
	],
	"get": function(wm, country){
		var idx = -1;
		if((idx = this.workmodes.findIndex((w)=>w.value == wm)) != -1 ){
			
			var wm = this.workmodes[idx];
			//we copy the layers object otherwise the urls would just be compiled with the coutry the first time
			if(wm._extraLayers)
				wm.extraLayers = structuredClone(wm._extraLayers);
			
			//add the country to the tiles url
			if(wm.extraLayers && wm.extraLayers.length){
				for (var i = 0; i < wm.extraLayers.length; i++) {
					 wm.extraLayers[i].source.tiles[0] = wm.extraLayers[i].source.tiles[0].replaceAll('{countryCode}', Country.getCode(country)).replaceAll('{countryName}', country.toLowerCase());
					 if(wm.extraLayers[i].source.promoteId){
						 var promotions = {}
						 wm.extraLayers[i].source.promoteId.forEach((promo)=>{
							 promotions[promo.layer.replaceAll('{countryCode}', Country.getCode(country))] = promo.property;
							 
						 });
						 wm.extraLayers[i].source.promoteId = promotions;
					 }
					 
					for (var j = 0; j < wm.extraLayers[i].layer.length; j++) {
						wm.extraLayers[i].layer[j]["source-layer"] = wm.extraLayers[i].layer[j]["source-layer"].replaceAll('{countryCode}', Country.getCode(country)).replaceAll('{countryName}', country.toLowerCase())
					}
				}
				
			}
			if(country){
				wm.obj.country = country.toLowerCase();
				wm.obj.countryCode = Country.getCode(country);
			}
			return this.workmodes[idx];
		}
		else
			return this.workmodes[1];
	}
	
}





export default wmConfig;


